module.exports = __webpack_public_path__ + "img/header-weddingRingsWomen@2x.b582627.webp";